export default __webpack_public_path__ + "static/media/logo.efdec902.png";